module.exports = __webpack_public_path__ + "176ef549268bcce6e4f8d727f4de6f69.png";